import { render, staticRenderFns } from "./SurveyFillerStartLanguageSelector.vue?vue&type=template&id=354d6e9b"
import script from "./SurveyFillerStartLanguageSelector.vue?vue&type=script&lang=js"
export * from "./SurveyFillerStartLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./SurveyFillerStartLanguageSelector.vue?vue&type=style&index=0&id=354d6e9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports